import { Icon } from '@assembly-js/design-system';

import { FilesTableData } from 'src/store/files/types';
import { FileUtils } from 'src/utils';
import { ensureUnreachable } from 'src/utils/common_utils';

import { IconWrapper } from './IconWrapper';

type Props = {
  file: FilesTableData;
};

export const FileIconRenderer = ({ file }: Props) => {
  switch (file.type) {
    case 'file':
      const extension = file.fileUrl
        ? 'link'
        : (file.fileKey && file.fileKey.split('.').pop()) || '';
      const icon = <IconWrapper extension={extension.toLowerCase()} />;
      return icon || null;
    case 'folder':
      return FileUtils.isReadOnly(file) ? (
        <Icon icon="FolderLocked" className="h-5 w-5 shrink-0" />
      ) : (
        <Icon icon="Files" className="h-5 w-5 shrink-0" />
      );
    default:
      return ensureUnreachable(file.type);
  }
};
